// extracted by mini-css-extract-plugin
export default {"root":"QuoteTabItem_root__igKuG","active":"QuoteTabItem_active__CXgXU","ul":"QuoteTabItem_ul__JeEMt"};